// import JSONAPIAdapter from '@ember-data/adapter/json-api';
import Application from './application';

export default class PersonAdapter extends Application {
  async claimUser(id) {
    var url = `${this.host}/people/${id}/claim`;

    let res = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...this.headers,
      },
    });
    if (res.status === 204) {
      return true;
    } else {
      return false;
    }
  }

  urlForQueryRecord(query) {
    let originalUrl = super.urlForQueryRecord(...arguments);
    if (query.me) {
      delete query.me;
      return `${originalUrl}/me`;
    }

    return originalUrl;
  }
}
